/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserEtcResponse
 */
export interface ApiUserEtcResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiUserEtcResponse
     */
    perimeter: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiUserEtcResponse
     */
    perimeterNames: Array<string> | null;
}

export function ApiUserEtcResponseFromJSON(json: any): ApiUserEtcResponse {
    return ApiUserEtcResponseFromJSONTyped(json, false);
}

export function ApiUserEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'perimeter': json['perimeter'],
        'perimeterNames': json['perimeterNames'],
    };
}

export function ApiUserEtcResponseToJSON(value?: ApiUserEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'perimeter': value.perimeter,
        'perimeterNames': value.perimeterNames,
    };
}

